import { handleActions } from 'redux-actions'

export default handleActions({}, {})
